<template>
  <div class="jzliu-bi-engine-dws-preview" v-if="dialogVisible">
    <template v-if="mode !== 'drawer'">
      <el-dialog top="5vh" width="90%" :visible.sync="dialogVisible" append-to-body :title="title">
        <dws-table :data="dwsData" @sort-change="handleSortChange" />
      </el-dialog>
    </template>
    <template v-else>
      <el-drawer class="jzliu-bi-engine-dws-preview-drawer" :visible.sync="dialogVisible" direction="btt" :title="title" append-to-body>
        <div slot="title">
          <span>{{ title }}</span>
          <el-tooltip content="仅展示最近1000条数据" placement="right">
            <i class="el-icon-info"></i>
          </el-tooltip>
        </div>
        <dws-table :data="dwsData" @sort-change="handleSortChange" />
      </el-drawer>
    </template>
  </div>
</template>

<script>
import dwsTable from './dwsTable.vue'
export default {
  name: "dwsPreview",
  components: { dwsTable },
  props: {
    mode: {
      type: String,
      default: 'drawer'
    },
    chartData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    title() {
      return this.chartData.dataSetName + '明细数据'
    },
    dwsData() {
      return this.chartData.dwsData || []
    }
  },
  data() {
    return {
      dialogVisible: false
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
    },
    handleSortChange(column) {
      this.$emit('sort-change', column)
    }
  }
}
</script>

<style scoped lang="less">
.jzliu-bi-engine-dws-preview {
  width: 100%;
  height: 100%;
}

/deep/ .el-dialog__body {
  max-height: none;
}
/deep/ .el-table__empty-block{
  min-height: 500px !important;
}
</style>

<style lang="less">
.jzliu-bi-engine-dws-preview-drawer .el-drawer__open .el-drawer.btt{
  height: 90% !important;
}
</style>